/* eslint-disable no-console */

const logger = {
  error: (...args: any[]): void => console.error(...args),
  warn: (...args: any[]): void => console.warn(...args),
  info: (...args: any[]): void => console.info(...args),
  debug: (...args: any[]): void => console.debug(...args),
};

export default logger;